import { MsalService } from '@azure/msal-angular';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';
import { SharedVariable } from './../../../custom-shared/util/shared-variable';
import { DialogBoxService } from './../../../custom-shared/components/alerts/dialog-box-service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormArray } from '@angular/forms';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { tap, filter, takeUntil } from 'rxjs/operators';
import { get, pickBy, omitBy, mergeWith, isNil } from 'lodash';
import { Store } from '@ngrx/store';

import * as fromStore from '@app/core/store';
import { ScreenComponent } from '@core/features/screen.component';
import * as fromMaster from '@features/master/create-user/store';

import { UserService } from '@services-api/user.service';
import { FeatureService } from '@services/feature/feature.service';
import { Nationality } from '@models/enums/nationality.enum';
import { Status } from '@models/enums/status.enum';
import { Language } from '@models/enums/language.enum';

import { environment } from '@env/environment';
import { FormControl } from '@angular/forms';

import { MatHorizontalStepper } from '@angular/material/stepper';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MasterConfirmedMessageComponent } from '../confirmed-message/master-confirmed-message.component';
import { MasterCreateUserService } from './master-create-user.service';
import { Client, CreateUserModel, SaveProfileRequest } from './master-create-user-model';
import { CaceisMessages } from '@app/custom-shared/consts/caceis-messages';
import { AppScreenUtil } from '@app/custom-shared/util/app-screen-util';
import { MasterClienteCreateUserService } from '../master-cliente/cliente-criar-usuario-stepper/master-cliente-create-user.service';
import { MasterBoPerfilAcessoComponent } from '@app/features/master-bo-perfil-acesso/master-bo-perfil-acesso.component';

/**
 * This Component manages the presentation logic of Edit screen
 *
 */
@Component({
  selector: 'app-master-create-user',
  templateUrl: './master-create-user.component.html',
  styleUrls: ['./master-create-user.component.scss'],
})
export class MasterCreateUserComponent extends ScreenComponent
  implements OnInit {
  vars: any = {};
  loading$: Observable<boolean>;
  data$: Observable<any>;
  clientsFantasyNameValues$: Observable<any>[] = [];
  ddiValues$: Observable<any>;
  nationalityValues$: Observable<any>;
  statusValues$: Observable<any>;
  languageValues$: Observable<any>;

  clientList: any[] = [];
  clientListDynamic: Array<Client[]> = [];

  form2: FormGroup;
  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper;

  keys = `userId,,,probgress,Dadospessoais,info,nacionalidade,nationality,lblCpf,cpf,passportnumber,passport,NOME,name,nascimento,birthDate,lblRg,rg,Dadosdecontato,email,login,celular,ddi,fone,ConfigConta,lblClientsPlus,clients.fantasyName,clients,Status,status,idioma,language,userSso`;
  errorInternet: string = '';
  teste: boolean = false;
  clientes$ = new BehaviorSubject<any[]>([]);
  isResident: boolean = false;
  isValidatedBycpfservice: boolean = false;
  customErrorMessage: string;
  isValidateByEmail: boolean = false;
  @ViewChild(MasterBoPerfilAcessoComponent) masterBoPerfilAcessoComponent!: MasterBoPerfilAcessoComponent;

  /**
   * Default Constructor of the component
   */
  constructor(
    private featureService: FeatureService,
    private service: UserService,
    public dialogRef: MatDialogRef<MasterCreateUserComponent>,
    private dialog: MatDialog,
    private repository: MasterCreateUserService,
    private snackBarService: DialogBoxService,
    private shared: SharedVariable,
    private msalService: MsalService,
    private profileService: ProfileManagerService,

    router: Router, private createUserService: MasterClienteCreateUserService,

    store: Store<fromMaster.State>,
    activeRoute: ActivatedRoute,
  ) {
    super(activeRoute, store, router);

    // Criação dos formularios de criar usuario
    this.form = this.createForm();
    this.form2 = this.createForm2();
  }

  getClientName(client: any) {
    return ""
  }

  ngOnInit() {
    super.ngOnInit();

    // carregar lista de clientes
    // this.service.listAllClients().subscribe(result => {
    //   this.clientList = result;
    //   this.clientListDynamic[0] = Object.assign([], this.clientList);
    // });

    this.parentCtx = this.getParentCtxParam();
    this.ctx = this.getScreenCtx();
    this.store.dispatch(fromMaster.initStateAction({ ...this.params }));
    this.store.dispatch(
      fromMaster.initValueAction({
        ...this.getPayload(),
        activeRoute: this.activeRoute,
      }),
    );

    this.data$ = this.store.pipe(
      fromStore.selectData(this.ctx),
      tap(item => this.init(item)),
    );
    this.loading$ = this.store.select(fromStore.selectLoading, this.ctx);
    this.store
      .select(fromStore.checkValidation, this.ctx)
      .pipe(filter(value => value))
      .subscribe(data => {
        const isValid = this.form.valid;
        if (!isValid) {
          this.featureService.validateForm(this.form);
        }
        this.store.dispatch(
          fromMaster.updateDataAction({
            ...this.getActionPayload(),
            isValid,
            value: { ...this.data },
          }),
        );
      });
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.data = mergeWith({ ...this.data }, { ...value }, (target, source) =>
        source === null || source instanceof Array ? source : undefined,
      );
    });
  }

  /**
   * Initialize the component by the provided data object
   * @param item
   */
  init(item) {
    this.data = { ...pickBy(this.data), ...omitBy(item, isNil) };
    this.featureService.patchValue(this.data, this.form);
    // const clientsValue = get(item, 'clients');
    // clientsValue &&
    //   clientsValue.forEach((rowValue, index) => {
    //     if (!this.clients.at(index)) {
    //       const clientsGroup = this.getClientsGroup();
    //       clientsGroup.patchValue(rowValue);
    //       this.clients.push(clientsGroup);
    //     } else {
    //       this.clients.at(index).patchValue(rowValue);
    //     }
    //     const clientsFantasyName = rowValue['name'];
    //   });

    const ddiValue = get(this.data, 'ddi');
    this.ddiValues$ = of(
      ddiValue ? [{ value: ddiValue, label: ddiValue }] : [],
    );
  }

  onChange() {
    // this.clientes$.next(this.form.value.clients);
  }

  validateRadioButton(): void {
    if (this.islblCpfVisible()) {
      this.form.controls['cpf'].markAsTouched({ onlySelf: true });
      this.isResident = true
    }

    if (this.ispassportnumberVisible()) {
      this.form.controls['passport'].markAsTouched({ onlySelf: true });
    }
  }

  /// Valida recursivamente todos os campos do form1(form)
  validateForm1(formGroup: FormGroup | FormArray): boolean {
    let isInvalid = this.form.invalid;

    if (isInvalid) {
      // this.form.controls['clients'].markAllAsTouched();

      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateForm1(control);
        }
      });
    }
    return !isInvalid;
  }

  validateAndGoToStep2() {
    let body = {}
    if (this.form.get('userSso').value != null && this.form.get('nationality').value == "residente") {
      if (this.form.get('cpf').value) {
        let cpf = this.form.get('cpf').value
            cpf = cpf.replaceAll('.','')
            cpf = cpf.replaceAll('-','')
             body = {
              // "login":this.msalService.instance.getAllAccounts()[0].name,
              "login":this.shared.userSso,
              "name": this.form.get('userSso').value,
              "cpf": cpf,
            }
      }
      this.repository.consultUserSSO(body).subscribe(res => {
      if (Number(res.result) < 100) {
        // this.teste = true;
        if (this.validateForm1(null) && this.isValidatedBycpfservice == true && this.isValidateByEmail == true) {
          this.teste = true;
          this.goToStep(1); // vai para o step 2
        }
      } else {
        setTimeout(() => {
          this.snackBarService.snackbarUtil.showError(
            res.messag,
          );
        }, 1500)
      }
    })

    } else {
      if (this.validateForm1(null) && this.isValidateByEmail == true) {
        this.teste = true;
        this.goToStep(1); // vai para o step 2
      }
    }

    // if(this.form.get('nationality').value == "residente") {
    //     if (this.validateForm1(null) && this.isValidatedBycpfservice == true && this.isValidateByEmail == true) {
    //       this.teste = true;
    //     this.goToStep(1); // vai para o step 2
    //   }
    // } else {
    //   if (this.validateForm1(null) && this.isValidateByEmail == true) {
    //     this.teste = true;
    //     this.goToStep(1); // vai para o step 2
    //   }
    // }


  }

  getSaveProfilePayload(): SaveProfileRequest {
    const payload: CreateUserModel = {
      ...this.form.value,
      ...this.form2.value,
    };

    const profile = payload.permissionGroups.profile;

    // const institutionOwner = payload.clients.map(({ name }) => ({ ...name }));
    const permissionGroupIds = payload.permissionGroups.permissionGroups.map(
      grupo => {
        return grupo.permissions
          .filter(permissao => {
            return permissao.checked == true;
          })
          .map(item => {
            return { id: item.id };
          });
      },
    );
    const permissions = [].concat(...permissionGroupIds);

    const saveProfileRequest = {
      profile: profile,
      institutionOwner: null,
      permissions: permissions,
    };

    return saveProfileRequest;
  }

  filterTypeUser(userNacionality, form, ids) {
    const { cpf, passport, ...restForm } = form;
    const formByTypeUser = {
      estrangeiro: { ...restForm, passport, permissionGroups: [...ids] },
      residente: { ...restForm, cpf, passport, permissionGroups: [...ids] },
    };

    return formByTypeUser[userNacionality];
  }

  getCreateUserPayload(ids: Array<{ id: string }>) {
    const formProps = { ...this.form.value };
    let payload = this.filterTypeUser(formProps['nationality'], formProps, ids);
    let cpf = this.form.get('cpf').value
    if(cpf){
      cpf = cpf.replaceAll('.','')
      cpf = cpf.replaceAll('-','')
    }
    payload.cpf=cpf
    return payload;
  }

  onSave() {
    let warnPerm :string;
    this.featureService.translatorService.
    getMessage('Selecione ao menos 1 relatório')
    .subscribe(
      data=>warnPerm=data
    )
    const saveProfilePayload = this.getSaveProfilePayload();
    console.log("saveProfilePayload",saveProfilePayload)
    // this.repository
    //   .saveProfile(saveProfilePayload)
    //   .toPromise()
    //   .then((result: Array<{ id: string }>) => {
        // const createUserPayload = this.getCreateUserPayload(result);
    let cpf = this.form.get('cpf').value
    if(cpf){
      cpf = cpf.replaceAll('.','')
      cpf = cpf.replaceAll('-','')
    }
    const isValid = this.masterBoPerfilAcessoComponent.validateCheckedItems();
    if (!isValid) {
      warnPerm.showWarn();
      return;
    }
        let body = {
          "cpf": cpf,
          "email": this.form.get('login').value,
          "idioma": this.form.get('language').value ,
          "nomeUsuario": this.form.get('name').value ,
          "perfil": "2",
          "usuario": this.form.get('userSso').value,
          // "ususarioMaster": this.msalService.instance.getAllAccounts()[0].name
          "ususarioMaster": this.shared.userSso
        }
        if (this.form.get('nationality').value == 'residente' && this.form.get('userSso').value) {
            this.repository.createUserSSO(body, saveProfilePayload).toPromise().then(res => {
              if(Number(res.result) <100) {
                this.repository
                  .saveProfile(saveProfilePayload).toPromise()
                    .then((result: Array<{ id: string }>)=> {
                      const createUserPayload = this.getCreateUserPayload(result);
                      this.repository
                      .createUser(createUserPayload).subscribe(res => {
                        this.closeWithoutAsk();
                          setTimeout(() => {
                            this.featureService.translatorService
                              .translateEnumItem(
                                CaceisMessages.SUCCESS_CREATE_USER,
                                'CaceisMessages'
                              )
                              .showSuccess()
                          }, 1500)
                      })
                    })

              } else {
                // this.closeWithoutAsk();
                setTimeout(() => {
                  this.featureService.translatorService
                    .translateEnumItem(
                      res.messag,
                      'CaceisMessages'
                    )
                    .showError()
                }, 1500)
              }

          }

          ).catch(err => {
            setTimeout(() => {
              this.featureService.translatorService
                .translateEnumItem(
                  CaceisMessages.SERVER_ERROR,
                  'CaceisMessages'
                )
                .showError()
            }, 1500)
          })
        } else {
          this.repository
            .saveProfile(saveProfilePayload)
            .toPromise().then((result: Array<{ id: string }>)=>{
              const createUserPayload = this.getCreateUserPayload(result);
                this.repository
              .createUser(createUserPayload).subscribe(res => {
                this.closeWithoutAsk();
                  setTimeout(() => {
                    this.featureService.translatorService
                      .translateEnumItem(
                        CaceisMessages.SUCCESS_CREATE_USER,
                        'CaceisMessages'
                      )
                      .showSuccess()
                  }, 1500)
              })
            })

        }


      // })


  }

  /// Avança um step da tela
  onNext(): void {
    this.stepper.next();
    AppScreenUtil.scrollModalToTop();
  }

  /// Retorna um step da tela
  onPrevious(): void {
    this.stepper.previous();
    AppScreenUtil.scrollModalToTop();
  }

  /// Muda para um step específico
  goToStep(index: number): void {
    this.teste = true;
    this.stepper.selectedIndex = index;
    AppScreenUtil.scrollModalToTop();
  }

  getStepOneIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-1';
    if (this.stepper.selectedIndex == 1) return 'icon-step-check';
  }

  getStepTwoIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-2';
    if (this.stepper.selectedIndex == 1) return 'icon-step-2';
  }

  getProgressBarValue(): number {
    if (this.stepper == null) return 50;

    if (this.stepper.selectedIndex == 0) return 50;
    if (this.stepper.selectedIndex == 1) return 100;
  }

  getPayload() {
    return {
      ...this.params,
      ...this.ctx,
      code: this.getCode(),
      keys: this.keys,
      parentCtx: { ...this.parentCtx },
    };
  }

  private getCode() {
    return this.parentCtx && this.parentCtx.code
      ? this.parentCtx.code
      : this.getParamCode();
  }
  private getParamCode() {
    const id = this.activeRoute.snapshot.params.id;
    return id && !id.startsWith('{') ? id : undefined;
  }

  private getParentCtxParam() {
    const id = this.activeRoute.snapshot.params.id;
    return id && id.startsWith('{') ? JSON.parse(id) : this.parentCtx;
  }

  getScreenCtx() {
    return fromStore.buildScreenCtx(
      'Master',
      'CreateUser',
      this.screenId,
      this.parentCtx ? this.parentCtx.roleName : null,
      this.parentCtx ? this.parentCtx.rootId : null,
      this.parentCtx && this.parentCtx.roleName
        ? this.screenId + ',' + this.parentCtx.screenId
        : null,
    );
  }

  /**
   * Get the data to dispatch by ngrx actions
   */
  getActionPayload() {
    return {
      ...this.params,
      ctx: { ...this.ctx },
      activeRoute: this.activeRoute,
      vars: { ...this.vars },
      keys: this.keys,
      data: { ...this.data },
      code: this.getCode(),
    };
  }

  createForm(): FormGroup {
    return this.featureService.formBuilder.group({
      probgress: [null, []],
      nationality: [null, [Validators.required]],
      cpf: [null, [Validators.required]],
      passport: [null, []],
      userSso: [null, [Validators.maxLength(50)]],
      login: [null, [Validators.required]],
      name: [null, [Validators.required, this.notOnlyWhitespace]],
      status: [null, [Validators.required]],
      language: [null, [Validators.required]],
    });
  }

  notOnlyWhitespace (control: FormControl) {
    if (!control.value || control.value.trim().length === 0) {
      return { notOnlyWhitespace: true };
    } else {
      return null;
    }
  }

  createForm2(): FormGroup {
    return this.featureService.formBuilder.group({
      profileId: [null, [Validators.required]],
      permissionGroups: [null, [Validators.required]],
    });
  }

  getDdiValues(): Observable<any> {
    this.store.dispatch(
      fromMaster.fetchFieldPossibleValuesAction({
        ...this.params,
        field: 'ddi',
        activeRoute: this.activeRoute,
        keys: undefined,
        separator: '|',
        data: this.data,
        vars: { ...this.vars, field: 'ddi' },
      }),
    );
    this.ddiValues$ = this.store.pipe(
      fromStore.selectPossibleValues(this.ctx, 'ddi'),
    );
    return this.ddiValues$;
  }

  getNationalityValues(): Observable<any> {
    return (this.nationalityValues$ =
      this.nationalityValues$ ||
      this.featureService.translatorService.enumValues(
        Nationality,
        'Nationality',
      ));
  }
  getStatusValues(): Observable<any> {
    return (this.statusValues$ =
      this.statusValues$ ||
      this.featureService.translatorService.enumValues(Status, 'Status'));
  }
  getLanguageValues(): Observable<any> {
    return (this.languageValues$ =
      this.languageValues$ ||
      this.featureService.translatorService.enumValues(Language, 'Language'));
  }

  getClientsGroup() {
    return this.featureService.formBuilder.group({
      name: [null,],
      institutionCode: [null,],
      legalName: [null,],
      cnpj: [null,],
    });
  }

  getClientsFantasyNameValues(index) {
    // this.store.dispatch(
    //   fromMaster.fetchFieldPossibleValuesAction({
    //     ...this.params,
    //     field: 'clients.name',
    //     activeRoute: this.activeRoute,
    //     keys: 'name',
    //     data: this.data,
    //     vars: { ...this.vars, index, field: 'clients.name' },
    //   }),
    // );
    // this.clientsFantasyNameValues$[index] = this.store.pipe(
    //   fromStore.selectPossibleValues(this.ctx, 'clients.name'),
    // );
    // return this.clientsFantasyNameValues$[index];
  }





  islblCpfVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality != 'estrangeiro';
  }

  iscpfVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality != 'estrangeiro';
    if (result !== true) {
      this.form.get('cpf').clearValidators();
      this.form.get('cpf').updateValueAndValidity();
    } else {
      this.form.get('cpf').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportnumberVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality == 'estrangeiro';
  }

  ispassportVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality == 'estrangeiro';
    if (result !== true) {
      this.form.get('passport').clearValidators();
      this.form.get('passport').updateValueAndValidity();
    } else {
      this.form.get('passport').setValidators([]);
    }
    return result;
  }

  ispassportRequired(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality == 'estrangeiro';
    if (result) {
      this.form.get('passport').setValidators([Validators.required]);
    }
    return result;
  }

  islanguageReadOnly(): boolean {
    const language =
      get(this.form.value, 'language') || get(this.data, 'language');
    return language == 'português';
  }

  cpfMaskfn() {
    return [
      /[0-9]/,
      /\d/,
      /\d/,
      '.',
      /[0-9]/,
      /\d/,
      /\d/,
      '.',
      /[0-9]/,
      /\d/,
      /\d/,
      '-',
      /[0-9]/,
      /\d/,
    ];
  }
  checkEmail(param) {
    console.log(param)
    this.form.get('login').setValue(this.form.get('login').value.toLowerCase());
    this.createUserService.CheckEmail(param).subscribe(res => {
      console.log("check", res)
      if (res != true) {
        
        if (param.split('@').length > 2) {
          this.form.controls['login'].setErrors({ invalid: true });
          this.isValidateByEmail = false
          return { invalid: true };
        }
    
       else if (!/\S+@\S+\.\S+/.test(param)) {
          this.form.controls['login'].setErrors({ invalid: true });
          this.isValidateByEmail = false
          return { invalid: true };
        }
    
       /*  this.form.controls['login'].setErrors(null);
        return { invalid: false }; */
        else {
          this.form.controls['login'].setErrors(null);
          this.isValidateByEmail = true
          return { invalid: false };
        }
      } else {
        this.form.controls['login'].setErrors({ invalid: true });
        this.isValidateByEmail = false
      }

    })
  }

  cpfValidate = param => {
    let val = param.replace(/[-.]/gi, '');
    val = val.replaceAll('_','')

    if (val.length === 11) {
      this.isValidatedBycpfservice = false

      let isCpfExistent: boolean;
      let cpfToString = param
      cpfToString = cpfToString.replaceAll('.','')
      cpfToString = cpfToString.replaceAll('-','')
      let payload = { cpf: cpfToString };
     
      let checkCPFService: Observable<any> = this.createUserService.checkCpf(payload);
      checkCPFService.subscribe(response => {
        isCpfExistent = response.isValidCpf;
        if (isCpfExistent) {
          this.isValidatedBycpfservice = false
          this.form.controls['cpf'].setErrors({ invalid: true });
          this.customErrorMessage = 'CPF já cadastrado';
          return { invalid: true };
        }
       else if(this.checkCpfValidity(val)){
        this.form.controls['cpf'].setErrors({ invalid: true });
        this.customErrorMessage = 'CPF inválido';
        return { invalid: true };
        }
         else {
          this.isValidatedBycpfservice = true
          this.form.controls['cpf'].setErrors(null);

        }
      });
    } else{
      this.isValidatedBycpfservice = false
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF já cadastrado';
      return { invalid: true };
}

 
  };

  checkCpfValidity(val){
    if (
      val == null ||
      val.length < 11 ||
      val == '00000000000' ||
      val == '11111111111' ||
      val == '22222222222' ||
      val == '33333333333' ||
      val == '44444444444' ||
      val == '55555555555' ||
      val == '66666666666' ||
      val == '77777777777' ||
      val == '88888888888' ||
      val == '99999999999'
    ) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF inválido';
      return  true ;
    }

    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(val.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(9))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF inválido';
      return  true 
    }
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(val.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(10))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      this.customErrorMessage = 'CPF inválido';
       true 
    }
    // this.form.controls['cpf'].setErrors(null);
    this.customErrorMessage = '';
    return  false 
  }
  date() {
    return [
      /[0-3]/,
      /[0-9]/,
      '/',
      /[0-1]/,
      /[0-9]/,
      '/',
      /[1-2]/,
      /([0|9])/,
      /[0-9]/,
      /[0-9]/,
    ];
  }

  dateValidate(date) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    const validYear = new Date().getFullYear() - 18;

    const [d, m, y] = date.split('/');
    const day = d < 0 || d > 31 ? false : true;
    const month = m < 1 || m > 12 ? false : true;
    const year = y > validYear && parseInt(y, 10) < 1900 ? false : true;

    if (y < 1870) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    if (!day || !month || !year) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['birthDate'].setErrors(null);
    return { invalid: false };
  }

  emailValidate = (email: string) => {
    this.checkEmail(email)
   /*  if (email.split('@').length > 2) {
      this.form.controls['login'].setErrors({ invalid: true });
      return { invalid: true };
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      this.form.controls['login'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['login'].setErrors(null);
    return { invalid: false };
 */
  };

  phoneMask() {
    return [
      '(',
      /\d/,
      /\d/,
      ')',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  phoneValidate(phone) {
    if (!/^[(]\d{2}[)]\d{5}-\d{4}/.test(phone)) {
      this.form.controls['fone'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['fone'].setErrors(null);
    return { invalid: false };
  }

  // get clients(): FormArray {
  //   return this.form.get('clients') as FormArray;
  // }

  // addClientsItem() {
  //   this.clients.push(this.getClientsGroup());
  //   this.clientsFantasyNameValues$.push(of({}));
  // }

  // removeClientsItem(index) {
  //   // this.clientList.push(this.clients.controls[index].value['name']);
  //   this.clients.removeAt(index);
  //   this.getClientList(index);
  //   this.clientsFantasyNameValues$.splice(index, 1);
  // }

  getClientList(index) {
    // this.clientListDynamic = [];

    // // this.clients.controls.forEach((control, i) => {
    // //   let arr = this.getClientListFiltered();

    // //   if (
    // //     control.value.name != '' &&
    // //     control.value.name != null &&
    // //     arr.indexOf(control.value.name) < 0
    // //   ) {
    // //     arr.push(control.value.name);
    // //   }
    // //   this.clientListDynamic.push(arr);
    // // });

    // if (this.clientListDynamic.length == 0) {
    //   this.clientListDynamic.push(this.clientList);
    // }

    // return this.clientListDynamic;
  }

  getClientListFiltered() {
    // let selectedClients = this.clients.controls
    //   .filter(control => {
    //     return (
    //       control.value != null &&
    //       control.value.name != '' &&
    //       control.value['name'] != null &&
    //       control.value['name'] != ''
    //     );
    //   })
    //   .map(control => control.value.name);

    // let result: Client[] = [];
    // result = this.clientList.filter(function (client) {
    //   let hasItem = false;

    //   selectedClients.forEach(seletedClient => {
    //     if (
    //       seletedClient.name != null &&
    //       seletedClient.name != '' &&
    //       seletedClient.name == client.name
    //     ) {
    //       hasItem = true;
    //     }
    //   });

    //   return !hasItem;
    // });

    // return result;
  }

  /**
   * Navigate to an auxiliary router outlet
   * @param {object} props
   */
  navigate(
    feature: string,
    screen: string,
    navigationType: string,
    roleName: string,
  ): void {
    this.featureService.navigate(
      feature,
      screen,
      navigationType,
      JSON.stringify({
        ...this.ctx,
        roleName,
        rootId: this.ctx.screenId,
      }),
      this.activeRoute,
    );
  }
  /**
   * Get date format from the profile
   * @param {string} temporalType
   * @param {string} datePrecision
   * @return {string} the date format
   */
  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(
      temporalType,
      datePrecision,
    );
  }

  validateNotSpecialCharacters(event: KeyboardEvent) {
    switch (event.keyCode) {
      case 8: // Backspace
      case 9: // Tab
      case 13: // Enter
      case 37: // Left
      case 38: // Up
      case 39: // Right
      case 40: // Down
        break;
      default:
        var regex = new RegExp('^[a-zA-Z0-9]+$');
        // var regex = new RegExp("^[a-zA-Z0-9.,/ $@()]+$");
        var key = event.key;
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
        break;
    }
  }

  closeWithoutAsk() {
    this.dialogRef.close();
  }

  close() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';

    this.dialog
      .open(MasterConfirmedMessageComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.dialogRef.close();
        }
      });
  }

  isMasterBO() {
    return this.profileService.isMasterBO();
  }

  isMasterCliente() {
    return this.profileService.isMasterClient();
  }
}
